import "./index.css";
import EditorComponent from "./Components/EditorComponent";


function App() {
  return (
    <div className="App">
      <EditorComponent />
    </div>
  );
}

export default App;
